
import "@/assets/hyper/css/icons.min.css";
import "@/assets/hyper/css/app-creative.min.css";
import Footer from "@/components/Footer.vue";
import Menu from "@/components/Menu.vue";
import Topbar from "@/components/Topbar.vue";
import Vue from "vue";
import { AuthService } from "@/services/Auth";
import TraduccionPagina from "@/components/Administracion/Traduccion/TraduccionPagina.vue";
import TareaPagina from "@/components/Administracion/Tareas/TareaPagina.vue";
import SeguimientoFactura from "@/components/Seguimiento/SeguimientoFactura.vue";
import { Utilidades } from "@/Util/Utilidades";
import { Postit, PostitFiltro } from "@/model/Postit";
import { PostitService } from "@/services/PostitService";
import { Constantes } from "@/Util/Constantes";

export default Vue.extend({
  name: "Home",
  data() {
    return {
      mensaje: "" as string,
      color: "" as string,
      showSnackbar: false as boolean,
      dialog: false as boolean,
      timeoutSnackBar: 2500 as number,
      interval: null,
      showRevalidarToken: true as boolean,
      currentPage: "" as string,
      dialogTraduccion: false as boolean,
      dialogTarea: false as boolean,
      dialogSeguimiento: false as boolean,
      dialogErrorSession: false as boolean,
      loading: false as boolean,
      loadingMantener: false as boolean,
      worker: null,
      isWorkerRunning: false,
      messages: [],
      postits: new Array<Postit>(),
      errorSession: "" as string,
    };
  },
  components: {
    Footer,
    Menu,
    Topbar,
    TraduccionPagina,
    TareaPagina,
    SeguimientoFactura,
  },
  async mounted() {
    var isAutenticado = true;

    if (isAutenticado) {
      await this.toggleWorker();
    }
    this.$root.$on("showSnackbar", this.snackbar);
    this.$root.$on("preloader", (x) => {
      this.loading = x;
    });

    await this.cargarPostits();
  },
  beforeDestroy() {
    this.$root.$off("showSnackbar", this.snackbar);
    this.$root.$off("preloader", () => {
      this.loading = false;
    });
    clearInterval(this.interval);

    this.terminateWorker();
  },
  watch: {
    "$store.state.loading": {
      immediate: true,
      deep: true,
      handler() {
        this.loading = this.$store.state.loading;
      },
    },
  },
  methods: {
    async revalidate() {
      this.loadingMantener = true;

      if (!Utilidades.getCookie(Constantes.SESSION_COOKIE)) {
        this.loadingMantener = false;
        AuthService.logout();
        return;
      }

      await AuthService.revalidarToken()
        .then((x) => {
          let token = x.data;
          if (token.split("#@#").length > 1) {
            Utilidades.setCookie(
              Constantes.SESSION_COOKIE,
              token.split("#@#")[1],
              AuthService.getUsuario().session_timeout
            );

            AuthService.updateToken(token.split("#@#")[0]);
          } else {
            AuthService.updateToken(token);
          }
          // AuthService.updateToken(x.data);

          clearInterval(this.interval);
          this.terminateWorker();
          this.interval = null;
          this.toggleWorker();

          this.mensaje = "Sessión activada con éxito!";
          this.color = "success";
          this.showSnackbar = true;
          this.dialog = false;
        })
        .catch(() => {
          this.loading = true;
          this.salir();
          //this.showSnackbar = true;
          //this.mensaje = "Error al continuar. Seras desconectado";
          //this.color = "error";
          //this.delayToRedirect(10000);
        })
        .finally(() => {
          this.loadingMantener = false;
        });
    },
    home() {
      let user = AuthService.getUsuario();

      if(user){
        return this.$route.name == "home" && user.id_perfil_seleccionado == Utilidades.UNO;
      }

      return false;
      
    },
    salir() {
      clearInterval(this.interval);
      this.$store.commit("stopTokenVerification");
      localStorage.removeItem("usuario");
      // this.$router.push({ name: "login" });
      AuthService.logout();
    },
    snackbar(ev) {
      if (ev.color == undefined || ev.color == null || ev.color == "") {
        ev.color = null;
      }

      if (ev.color != null) {
        this.color = ev.color;
      } else {
        this.color = !ev.error ? "success" : "error";
      }
      this.timeoutSnackBar = !ev.timeout ? 5000 : ev.timeout;

      let positionDefecto = !ev.left && !ev.top && !ev.bottom;

      this.messages.push({
        message: ev.mensaje,
        top: ev.top,
        bottom: ev.bottom,
        left: ev.left,
        right: positionDefecto,
        color: this.color,
        icono: Utilidades.isNullOrUndefinedOrEmpty(ev.icono)
          ? "mdi-close-circle"
          : ev.icono,
        // transition: this.transitions[randomTransition],
        timeout: this.timeoutSnackBar,
      });

      // this.showSnackbar = false;
      // this.mensaje = ev.mensaje;
      // this.showSnackbar = true;

      // if(ev.color == undefined ||ev.color == null || ev.color == ''){
      //   ev.color = null;
      // }

      // if(ev.color!=null){
      //   this.color = ev.color;
      // }else{
      //   this.color = !ev.error ? "success" : "error";
      // }
      // this.timeoutSnackBar = !ev.timeout ? 5000 : ev.timeout;
    },
    abrirModalTagsPagina() {
      (this.$refs.traduccionPagina as any).cargarTags();
      this.dialogTraduccion = true;
    },
    abrirModalTareasPagina() {
      (this.$refs.tareaPagina as any).cargarTareasPagina();
      this.dialogTarea = true;
    },
    abrirModalSeguimiento(id_factura, titulo) {
      (this.$refs.seguimientoFactura as any).cargarSeguimiento(
        id_factura,
        titulo
      );
      this.dialogSeguimiento = true;
    },
    isAuthenticated() {
      if (this.dialogErrorSession) return;

      var cookie_exp = Utilidades.getCookieExpiration(
        Constantes.SESSION_COOKIE
      );
      var fecha_ahora = new Date();
      fecha_ahora.setTime(fecha_ahora.getTime() + 60000); //1 minuto

      // console.log("Ahora: " + fecha_ahora);

      if (!cookie_exp) {
        AuthService.logout();
      }

      if (fecha_ahora > cookie_exp) {
        this.dialog = true;
        this.showRevalidarToken = true;
        this.terminateWorker();
        this.delayToRedirect();
        return;
      }
    },
    delayToRedirect(miliseconds = 30000) {
      clearInterval(this.interval);

      this.interval = setInterval(() => {
        this.salir();
        //clearInterval(this.interval);
      }, miliseconds); //30 Segundos
    },
    toggleWorker() {
      if (this.isWorkerRunning) {
        this.terminateWorker();
        this.startWorker();
      } else {
        this.startWorker();
      }
    },
    terminateWorker() {
      if (this.worker) {
        this.worker.terminate();
        this.worker = null;
        this.isWorkerRunning = false;
      }
    },
    startWorker() {
      if (typeof Worker !== "undefined") {
        this.worker = new Worker("/Counter.js");
        this.worker.addEventListener("message", (e) => {
          this.isAuthenticated();
        });

        // this.worker.postMessage({ delayedAction: "start", delay: 1 });
      } else {
        console.log("No hay suporte");
      }
    },
    async cargarPostits() {
      let filtro = new Object() as PostitFiltro;

      await PostitService.getPostits(filtro).then((x) => {
        this.postits = x.data;
      });
    },
    sessionError(error) {
      if (Utilidades.isNullOrUndefinedOrEmpty(error)) {
        error =
          "Ocurrió un error en la sesión actual, inicie sesión nuevamente.";
      }

      this.errorSession = error;
      this.dialogErrorSession = true;

      Utilidades.deleteCookie(Constantes.SESSION_COOKIE);

      clearInterval(this.interval);

      this.interval = setInterval(() => {
        this.salir();
      }, 15000); //15 Segundos
    },
  },
});
